import React from 'react';
import { SYSTEM_ICON_SIZES } from '../../constants';
import { getStrokeColor } from '../../utils';
import type { SystemIconType } from '../../types';
import { pascalToSnake } from '../../../utils';

const ChevronRightIcon = ({
  size = 'sm',
  color = 'currentColor',
  dataTrackTag = pascalToSnake('ChevronRightIcon'),
}: SystemIconType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={SYSTEM_ICON_SIZES[size]}
    height={SYSTEM_ICON_SIZES[size]}
    fill="none"
    viewBox="0 0 16 17"
    data-track-tag={dataTrackTag}
  >
    <path
      stroke={getStrokeColor(color)}
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit={16}
      strokeWidth={1.5}
      d="m6 4.818 4 4-4 4"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);
ChevronRightIcon.id = 'ChevronRightIcon';
ChevronRightIcon.displayName = 'ChevronRightIcon';
export default ChevronRightIcon;
